import { camelizeKeys } from 'humps';
import orderBy from 'lodash/orderBy';
import sortBy from 'lodash/sortBy';

import { MAX_RECENT_BRAND_USERS, MAX_RECENT_USERS_FILTER_LIST } from '@/app/community/constants';

export function formatUser(user = {}) {
  const _user = camelizeKeys(user);
  const firstName = _user?.firstName || '';
  const lastName = _user?.lastName || '';
  const fullName = `${firstName} ${lastName}`.trim();

  return {
    label: fullName,
    value: _user?.id,
    firstName,
    lastName,
    avatarUrl: _user?.avatarUrl,
    type: 'item',
  };
}

export function getMostRecentUserIds({
  comments,
  identity,
  limit = MAX_RECENT_USERS_FILTER_LIST,
} = {}) {
  const sorted = orderBy(comments || [], ['createdAt', 'id'], ['desc', 'desc']);

  const ids = sorted
    .map(({ userId, text }) => {
      const parsed = parseInt((text || '').replaceAll(/[@[\]]/gi, ''), 10);
      return Number.isNaN(parsed) ? userId : parsed;
    })
    .filter((n) => n !== identity?.id);

  return [...new Set(ids)].slice(0, limit);
}

export function getCurrentAndUnassignedUser(identity) {
  const userItems = [];
  if (identity) {
    // push the current user first
    userItems.push({
      ...formatUser(identity),
      note: '(You)',
    });
  }
  // push unassigned filter option and a divider line
  userItems.push({
    label: 'Unassigned',
    firstName: '',
    lastName: '',
    value: -1,
    avatarUrl: null,
    type: 'item',
  });
  userItems.push({
    type: 'line',
    divider: true,
  });
  return userItems;
}

export function getMostRecentUsers({ identity, mostRecentUserIds = [], accessibleUsers = [] }) {
  const userItems = getCurrentAndUnassignedUser(identity);
  if (accessibleUsers) {
    if (mostRecentUserIds?.length) {
      // push the most recent users
      const recentUsers = accessibleUsers
        .filter((user) => mostRecentUserIds.includes(user.id))
        .sort((a, b) => mostRecentUserIds.indexOf(a.id) - mostRecentUserIds.indexOf(b.id))
        .map((user) => formatUser(user));
      if (recentUsers?.length) {
        const topMostRecentUsers = recentUsers.slice(0, MAX_RECENT_BRAND_USERS);
        userItems.push(...topMostRecentUsers);
        if (recentUsers.length > topMostRecentUsers.length) {
          const remainingMostRecentUsers = sortBy(recentUsers.slice(MAX_RECENT_BRAND_USERS), [
            'firstName',
            'lastName',
          ]);
          userItems.push({ type: 'line' });
          userItems.push(...remainingMostRecentUsers);
        }
      }
    }
  }
  return userItems;
}

export function getBrandAssignUserOptions({
  identity,
  accessibleUsers = [],
  recentAssignments,
  includeUnassigned = true,
  recentUserLimit = MAX_RECENT_BRAND_USERS,
} = {}) {
  const mostRecentUserIds = getMostRecentUserIds({
    comments: recentAssignments,
    identity,
    limit: recentUserLimit,
  });
  let recentSection = getMostRecentUsers({
    identity,
    mostRecentUserIds,
    accessibleUsers,
  });
  if (!includeUnassigned) {
    recentSection = recentSection.filter((user) => user.value !== -1);
  }
  const pinnedUserIds = [...mostRecentUserIds, identity?.id].filter(Boolean);
  const remainingUsers = accessibleUsers
    .filter((user) => !pinnedUserIds.includes(user.id))
    .map((user) => formatUser(user));
  return [...recentSection, ...remainingUsers];
}
